import axios from '../helpers/axiosConfig';
import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../helpers/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import getBaseUrl from '../helpers/utility';

const PersonnelsRetraite = () => {
  const baseUrl = getBaseUrl();

  const navigate = useNavigate();
  const [personnels, setPersonnels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(0);

  /*   const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (isAuthenticated.isAuthenticated) {
      navigate('/login');
    }
  }, []); */

  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    const fetchPersonnels = async () => {
      toast.info('Chargement des données ...');
      try {
        const response = await axios.get('/personnel', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.data;

        const today = new Date();
        const yearInTwoYears = today.getFullYear() + 2;

        const personnelsRetraite = data.personnels.filter((personnel) => {

          if (personnel.typePers === 'CIVIL') {
            if (personnel.datenaisse) {

              const birthDate = new Date(personnel.datenaisse);

              const retirementAge = personnel.grade.anneeretraite; // 'anneedeservice' stocke l'âge de retraite pour chaque grade
              const retirementYear = birthDate.getFullYear() + retirementAge;

              // Filtrer les personnels dont l'année de retraite est dans les 2 années suivantes
              return retirementYear <= yearInTwoYears && retirementYear >= today.getFullYear();
            }
          }
        });
        // Trier les personnels par année de retraite en ordre croissant
        personnelsRetraite.sort((a, b) => {
          const retirementYearA = new Date(a.datenaisse).getFullYear() + a.grade.anneeretraite;
          const retirementYearB = new Date(b.datenaisse).getFullYear() + b.grade.anneeretraite;

          return retirementYearA - retirementYearB; // Tri par année de retraite en ordre croissant
        });
        setPersonnels(personnelsRetraite);
      } catch (err) {
        toast.error(err);
      }
    };

    fetchPersonnels();
  }, []);

  return (
    <div className="max-w-7xl mx-auto p-6">

      {personnels.length === 0 ? (

        <div className="flex justify-center items-center py-20">

          <div className="text-center">

            <i className="fa fa-spinner fa-spin text-5xl text-gray-400"></i>

            <p className="mt-4 text-xl text-gray-600">
              Chargement des données...
            </p>

          </div>

        </div>

      ) : (

        <>

          {/* Titre */}

          <div className="mb-6">

            <h1 className="text-4xl font-bold text-gray-800">

              👴 Retraités dans les années suivantes

            </h1>

            <p className="mt-2 text-lg text-gray-500">

              Liste des personnels qui partiront à la retraite

            </p>

          </div>


          {/* Nombre de résultats */}

          <div className="mb-6 bg-red-50 border border-red-200 rounded-2xl p-6 shadow-sm">

            <div className="flex items-center justify-between p-6 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300 group">
              <div>
                <p className="text-sm font-semibold tracking-wide text-slate-500 uppercase">
                  Résultats trouvés
                </p>

                <div className="flex items-baseline gap-2 mt-2">
                  <h2 className="text-5xl font-black text-slate-900 tracking-tight">
                    {personnels.length.toLocaleString('fr-FR')}
                  </h2>
                  <span className="text-xs font-semibold text-rose-600 bg-rose-50 px-2 py-0.5 rounded-md">
                    Civils
                  </span>
                </div>
              </div>

              {/* Icône stylisée dans son cercle avec effet au survol de la carte */}
              <div className="w-14 h-14 rounded-2xl bg-rose-50 text-rose-500 flex items-center justify-center group-hover:bg-rose-500 group-hover:text-white transition-all duration-300 shadow-inner">
                <i className="fa fa-users text-2xl"></i>
              </div>
            </div>

          </div>


          {/* Tableau */}

          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">

            <div className="overflow-x-auto">

              <table className="min-w-full">

                <thead className="bg-gray-800 text-white text-lg">

                  <tr>

                    <th className="px-6 py-4 text-left">Grade</th>

                    <th className="px-6 py-4 text-left">Nom et prénoms</th>

                    <th className="px-6 py-4 text-left">Date de naissance</th>

                    <th className="px-6 py-4 text-left">Ets / Sce / Compagnie</th>

                    <th className="px-6 py-4 text-left">Retraite</th>

                    <th className="px-6 py-4 text-center">Photo</th>

                    <th className="px-6 py-4 text-center">Actions</th>

                  </tr>

                </thead>

                <tbody className="divide-y divide-gray-200 text-lg">

                  {personnels.map((personnel) => (

                    <tr
                      key={personnel.id}
                      className="hover:bg-gray-50 transition"
                    >

                      <td className="px-6 py-4 font-semibold">

                        {personnel.grade.name}

                      </td>

                      <td className="px-6 py-4">

                        {personnel.nomprenom}

                      </td>

                      <td className="px-6 py-4">

                        {personnel.datenaisse}

                      </td>

                      <td className="px-6 py-4">

                        {personnel.etsouservice?.name}

                        {personnel.compagnie?.name}

                      </td>

                      <td className="px-6 py-4 font-semibold text-red-600">

                        Retraite en{" "}

                        {new Date(personnel.datenaisse).getFullYear() +
                          personnel.grade.anneeretraite}

                      </td>

                      <td className="px-6 py-4 flex justify-center">

                        <img
                          src={`${baseUrl}/images/personnels/${personnel.filename}`}
                          alt=""
                          className="w-16 h-16 rounded-full object-cover border-2 border-gray-300"
                        />

                      </td>

                      <td className="px-6 py-4">

                        <div className="flex justify-center gap-4">

                          <button
                            onClick={() =>
                              navigate(`/personnel/${personnel.id}`)
                            }
                            className="w-11 h-11 flex items-center justify-center rounded-xl bg-blue-600 hover:bg-blue-700 text-white transition"
                          >

                            <i className="fa fa-eye text-lg"></i>

                          </button>

                          <button
                            onClick={() =>
                              navigate(`/personnel/edit/${personnel.id}`)
                            }
                            className="w-11 h-11 flex items-center justify-center rounded-xl bg-amber-500 hover:bg-amber-600 text-white transition"
                          >

                            <i className="fa fa-edit text-lg"></i>

                          </button>

                        </div>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        </>

      )}

    </div>
  );
};

export default PersonnelsRetraite;
